// extracted by mini-css-extract-plugin
export default {"backLink":"BackLink_backLink__9wtqs","uc-icon":"BackLink_uc-icon__+Dnlt","label":"BackLink_label__oxU1D"};